<template>
  <div class="flex flex-col gap-4 w-full h-full items-center justify-center">
    <h1 class="text-4xl">
      <b>404 - PAGE NOT FOUND</b>
    </h1>
    <router-link
      to="/"
      class="text-blue-500 hover:underline text-3xl"
    >
      Go to Home
    </router-link>
  </div>
</template>
